import { useEffect, useState } from "react";
import { api, puede, type Cita } from "../api.ts";
import { fechaLarga, horaLarga, NOMBRE_ESTADO_CITA } from "../../../dominio/src/index.ts";
import { hoy, Seccion } from "./comun.tsx";
import { useClinica } from "../clinica.ts";

/** Próximas citas del paciente en su ficha, con acceso directo para agendar. */
export function CitasPaciente({ pacienteId }: { pacienteId: string }) {
  const [citas, setCitas] = useState<Cita[] | null>(null);
  const conSedes = (useClinica()?.sedes ?? []).filter((x) => x.activa).length > 1;
  useEffect(() => { if (puede("agenda:leer")) api<Cita[]>("GET", `/api/pacientes/${pacienteId}/citas`).then(setCitas).catch(() => setCitas([])); }, [pacienteId]);
  if (!citas) return null;
  const proximas = citas.filter((c) => c.fecha >= hoy() && ["agendada", "confirmada"].includes(c.estado)).reverse();
  const pasadas = citas.filter((c) => !proximas.includes(c)).slice(0, 3);
  return (
    <Seccion titulo="Citas" acciones={puede("agenda:escribir") && <a className="btn chico pri" href={`#/agenda?paciente=${pacienteId}`}>Agendar cita</a>}>
      {proximas.length === 0 && <p className="muted" style={{ margin: 0 }}>Sin citas próximas.</p>}
      {proximas.map((c) => (
        <div key={c.id} className="fila"><span className={`chip e-${c.estado}`}>{NOMBRE_ESTADO_CITA[c.estado]}</span><b>{fechaLarga(c.fecha)}, {horaLarga(c.hora)}</b><span className="muted">{c.motivo} · {c.profesional}{conSedes && c.sede ? ` · ${c.sede}` : ""}</span></div>
      ))}
      {pasadas.length > 0 && <span className="muted" style={{ fontSize: 13 }}>Anteriores: {pasadas.map((c) => `${c.fecha} (${NOMBRE_ESTADO_CITA[c.estado].toLowerCase()})`).join(" · ")}</span>}
    </Seccion>
  );
}
